/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Commons_Header_User_LabelInputs */

const de_commons_header_user_label = /** @type {(inputs: Commons_Header_User_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzerprofil`)
};

/** @type {(inputs: Commons_Header_User_LabelInputs) => LocalizedString} */
const en_commons_header_user_label = de_commons_header_user_label;

/**

* @param {Commons_Header_User_LabelInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const commons_header_user_label = /** @type {((inputs?: Commons_Header_User_LabelInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Commons_Header_User_LabelInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_commons_header_user_label(inputs)
	return en_commons_header_user_label(inputs)
});